import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';//
import { catchError, debounceTime, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

const baseApiIpTackCheckin = environment.baseApiIp;
const baseApiTalkphr = environment.baseApiIpTalkPhr;
const baseApiIpSymptom = environment.baseApiIpSymptoms;
const baseAPIOTP = environment.baseAPIOTP;
declare var $: any;

const httpOptionsTalkpr = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable({
  providedIn: 'root'
})
export class GenericUtilityService {
  constructor(public _httpClient: HttpClient) {
    
  }
  getBaseIpTalkPhr() {
    return baseApiTalkphr;
  }
  getBaseIpDataScience() {
    return baseApiIpTackCheckin;
  }
  
  ApiGetMethod(params: string): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + localStorage.getItem("AuthToken"),
      })
    };
    let url: string = baseApiIpTackCheckin + 'api/' + params;
    return this._httpClient.get(url, httpOptions).pipe(catchError(this.handleError));
  }
  ApiPostMethod(ControllerName: string, ActionName: string, data: any): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Token': 'Bxxbh!W-cNm_T&N-RJ7$6h6u64Hx@Uc#2%$YQwq6VLfjmj=Rg-!4M9hHDpQKdby+',
        'Authorization': "Bearer " + localStorage.getItem("AuthToken"),
      })
    };
    let url: string = baseApiIpTackCheckin + 'api/' + ControllerName + '/' + ActionName;
    return this._httpClient.post(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  getTokenForDataScience(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cookie': 'JSESSSIONID=934636.1.435345.345345'
    });

    const body = {
      USER_NAME: 'data_security',
      PWD: 'secure@1234'
    };
    let url: string = baseApiIpTackCheckin + 'api/auth/get_token';
    return this._httpClient.post(url, body, { headers }).pipe(
      catchError(error => {
        console.error('API Error:', error);
        return throwError(() => error); // stop further chaining
      })
    );
  }

  token:any = "";
  ApiGetMethodTalkphr(params: string): any {
    //use the JWT token in the requested headers

    this.token = localStorage.getItem("AuthTokenwebServices");
    if (!this.token || this.token == '' || this.token == undefined) {

      this.token = sessionStorage.getItem("AuthTokenwebServices");
      console.log("Getting token from ss GET " + this.token);
    }

    const httpOptionsTalkprJWT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + this.token,
      })
    };
    
    let url: string = baseApiTalkphr + 'api/' + params;
    
    console.log("ttttt " + this.token);
    console.log("uuuu "+url);
    return this._httpClient.get(url, httpOptionsTalkprJWT).pipe(catchError(this.handleError));
  }

  ApiGetMethod_register(params: string): any {
    //use the JWT token in the requested headers

    const httpOptionsTalkprJWT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': '652*3121119876543210*2*1AHS*eulaV4@tt*esarhP4@tt*==AhVRnOMTXSpenbctUjp+Ar',
      })
    };

    let url: string = baseApiTalkphr + 'api/' + params;

    return this._httpClient.get(url, httpOptionsTalkprJWT).pipe(catchError(this.handleError));
  }
  ApiGetMethodStandAlone(params: string): any {
    //use the JWT token in the requested headers
    const httpOptionsTalkprJWT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'api_Key': '652*3121119876543210*2*1AHS*eulaV4@tt*esarhP4@tt*==AhVRnOMTXSpenbctUjp+Ar',
      })
    };
    let url: string = baseApiTalkphr + 'api/' + params;
    // console.log("ttttt " + this.token);
    //  console.log("uuuu " + url);
    return this._httpClient.get(url, httpOptionsTalkprJWT).pipe(catchError(this.handleError));
  }

  ApiGetMethodTalkphrWithoutAuth(params: string): any {
   
    const httpOptionsTalkprJWT = {
      headers : new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'api_key': '652*3121119876543210*2*1AHS*eulaV4@tt*esarhP4@tt*==AhVRnOMTXSpenbctUjp+Ar' // Add your actual API key here
      })
    };

    let url: string = baseApiTalkphr + 'api/' + params;

    return this._httpClient.get(url, httpOptionsTalkprJWT).pipe(catchError(this.handleError));
  }

  ApiPostMethodTalkphr(ControllerName: string, ActionName: string, data: any): any {

    this.token = localStorage.getItem("AuthTokenwebServices");
    if (!this.token || this.token == '' || this.token == undefined) {

      this.token = sessionStorage.getItem("AuthTokenwebServices");
      console.log("Getting token from ss POST " + this.token);
    }

    //use the JWT token in the requested headers
    const httpOptionsTalkprJWT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + this.token,
      })
    };
    let url: string = baseApiTalkphr + 'api/' + ControllerName + '/' + ActionName;
    return this._httpClient.post(url, data, httpOptionsTalkprJWT).pipe(catchError(this.handleError));
  }

  ApiPostMethodTalkphrWithoutAuth(ControllerName: string, ActionName: string, data: any): any {


    const httpOptionsTalkprJWT = {
      headers : new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'api_key': '652*3121119876543210*2*1AHS*eulaV4@tt*esarhP4@tt*==AhVRnOMTXSpenbctUjp+Ar'
      })
    };
    let url: string = baseApiTalkphr + 'api/' + ControllerName + '/' + ActionName;
    return this._httpClient.post(url, data, httpOptionsTalkprJWT).pipe(catchError(this.handleError)).toPromise();

  }
  
  ApiPostMethodTalkphrEncDec(ControllerName: string, ActionName: string, data: any): any {
    let h = new HttpHeaders({
      'content-type' : 'application/json',
      'Access-Control-Allow-Origin' : '*'
    });
    let url: string = baseApiTalkphr + 'api/' + ControllerName + '/' + ActionName;
    return this._httpClient.post(url, data,  {headers: h, responseType: 'text'}).pipe(catchError(this.handleError));
  }
  
  ApiPostMethodOTP(controllerName: string, methodName: string, obj: any): any {
    let url = baseAPIOTP+'api/'+controllerName+'/'+methodName;
    return this._httpClient.post(url, obj).pipe(catchError(this.handleError));
  }
  
  ApiGetMethodSymptoms(params: string): any {
    const httpOptionsforSymptoms = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "Access-Control-Allow-Credentials": "true",
        // "Authorization": "Basic dGFsa2Vocjpkc3RlYW1AMTIz",
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + localStorage.getItem("AccessTokenSymptoms"),
      })
    };
    let url: string = baseApiIpSymptom + params;
    return this._httpClient.get(url, httpOptionsforSymptoms).pipe(catchError(this.handleError));
  }
  
  ApiPostMethodSymptoms(ControllerName: string, data: any): any {
    const httpOptionsforSymptoms = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "Access-Control-Allow-Credentials": "true",
        // "Authorization": "Basic dGFsa2Vocjpkc3RlYW1AMTIz",
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + localStorage.getItem("AccessTokenSymptoms"),
      })
    };
    let url: string = baseApiIpSymptom + ControllerName ;
    return this._httpClient.post(url, data, httpOptionsforSymptoms).pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
  GenericExternalServiceCallerGet(URL: string): any {
    var listofRecords = this._httpClient.get(URL)
    .pipe(
      debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
      map(
        (data: any) => {
          return (
            data.length != 0 ? data as any[] : "No Record Found"
            );
          }
          ), catchError(this.handleError));
          
          return listofRecords;
        }
        GenericExternalServiceCallerPost(URL: string, data: any): any {
          var listofRecords = this._httpClient.post(URL, data)
          .pipe(
            debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
            map(
              (data: any) => {
                return (
                  data.length != 0 ? data as any[] : "No Record Found"
                  );
                }
                ), catchError(this.handleError));
                
                return listofRecords;
              }
              
            }
